import React, { useState } from "react";

// Clearable number input: hält lokalen Entwurf, damit man auf dem Handy die
// Zahl komplett löschen kann (keine erzwungene führende Ziffer / keine Rück-auf-0).
// Committet erst bei gültiger Eingabe; leeres Feld -> emptyValue beim Verlassen.
export function NumInput({ value, onChange, unit = 1, emptyValue, className, testId, step, min, max, placeholder, disabled, title, onClick }) {
  const [draft, setDraft] = useState(null);
  const fmt = (v) => (v == null || Number.isNaN(v) ? "" : String(Math.round((v / unit) * 1000) / 1000));
  const disp = draft !== null ? draft : fmt(value);
  return (
    <input
      type="number" inputMode="decimal" step={step} min={min} max={max} placeholder={placeholder}
      disabled={disabled} title={title} onClick={onClick} className={className} data-testid={testId}
      value={disp}
      onFocus={() => setDraft(fmt(value))}
      onChange={(e) => { const v = e.target.value; setDraft(v); if (v !== "" && !Number.isNaN(Number(v))) onChange(Math.round(Number(v) * unit)); }}
      onBlur={() => {
        if (draft === "") {
          if (emptyValue === null) onChange(null);
          else if (typeof emptyValue === "number") onChange(emptyValue);
          // sonst: Pflichtfeld -> auf aktuellen Wert zurücksetzen (kein 0)
        }
        setDraft(null);
      }}
    />
  );
}
